import { Box, Typography } from "@mui/material";

import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';

import { useEffect, useState } from "react";

import Fetch from "../../services/Fetch";

import PageHero from "../../components/motion/PageHero";

import ScrollReveal from "../../components/motion/ScrollReveal";

import DashboardPanelCard from "../../components/cards/DashboardPanelCard";

import { useConstants } from "../../hooks/UseConstants";

import { getNotificationText } from "../../helper/notificationText";



function parseList(result) {

    if (result?.status !== 200) return [];

    const payload = result.data?.data;

    return Array.isArray(payload) ? payload : (payload?.data || []);

}



function Notifications() {

    const { host, language } = useConstants();

    const isAr = language === 'ar';

    const [loading, setLoading] = useState(true);

    const [items, setItems] = useState([]);



    useEffect(() => {

        const load = async () => {

            setLoading(true);

            const result = await Fetch(`${host}/notification/history?per_page=50`, 'GET');

            setItems(parseList(result));

            setLoading(false);

        };

        load();

    }, [host]);



    if (loading) {

        return (

            <Box className="flex justify-center py-20">

                <Typography color="text.secondary">{isAr ? 'جاري التحميل...' : 'Loading...'}</Typography>

            </Box>

        );

    }



    return (

        <Box>

            <PageHero

                title={isAr ? 'الإشعارات' : 'Notifications'}

                subtitle={isAr ? 'آخر التحديثات والتنبيهات الخاصة بك' : 'Your latest updates and alerts'}

                icon={<NotificationsNoneOutlinedIcon />}

            />

            {items.length === 0 ? (

                <Typography color="text.secondary" className="text-center py-12">

                    {isAr ? 'لا توجد إشعارات' : 'No notifications'}

                </Typography>

            ) : (

                <DashboardPanelCard className="mx-0">

                    {items.map((n, i) => {

                        const { title, body } = getNotificationText(n, isAr);

                        return (

                            <ScrollReveal key={n.id || i} delay={i * 40} direction="up">

                                <Box sx={{ py: 1.5, borderBottom: 1, borderColor: 'divider' }}>

                                    <Typography variant="body2" fontWeight={600}>{title}</Typography>

                                    {body ? (

                                        <Typography variant="caption" color="text.secondary" display="block">

                                            {body}

                                        </Typography>

                                    ) : null}

                                    {n.created_at ? (

                                        <Typography variant="caption" display="block" color="text.disabled" sx={{ mt: 0.5 }}>

                                            {n.created_at}

                                        </Typography>

                                    ) : null}

                                </Box>

                            </ScrollReveal>

                        );

                    })}

                </DashboardPanelCard>

            )}

        </Box>

    );

}



export default Notifications;


